const $ = jQuery;

export default class Nav {
    constructor() {
        const $nav = $('.section-navigation');
        const navigationIntersectionObserver = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting){
                $nav.addClass('stickyPillars');
            }
        },
          { rootMargin: '0px 0px -92% 0px' }
        );
        const stickyPillarIntersectionObserver = new IntersectionObserver((entries) => {
              if (!entries[0].isIntersecting){
                  $nav.removeClass('stickyPillars');
              }
          }
        );
        // start observing
        const nav = document.querySelector('.section-navigation');
        if(nav){
            navigationIntersectionObserver.observe(nav);
        }
        const block = document.querySelector('.block--textpicfullwidth');
          if(block){
              stickyPillarIntersectionObserver.observe(block);
          }
    }
}



// WEBPACK FOOTER //
// ./app/themes/template/res/js/src/StickyPillars.js